import React, { useState } from 'react';
import { useData } from '../../../hooks/useData';
import { useApp } from '../../../contexts/AppContext';
import { TABLES } from '../../../constants';
import TaskTable from './TaskTable/TaskTable';
import GanttChart from './GanttChart/GanttChart';
import pageStyles from '../../../styles/pages.module.css';

export default function SchedulePage() {
  const [activeTab, setActiveTab] = useState(0);
  const { currentProject } = useApp();

  const {
    data: tasks,
    isLoading,
    error,
    manageTasks,
  } = useData(TABLES.PROJECT_TASKS, {
    filter: { project_id: currentProject?.id },
    realtime: true,
  });

  if (isLoading) return <div className={pageStyles.loadingContainer}>Loading...</div>;
  if (error) return <div className={pageStyles.emptyState}>Error: {error.message}</div>;

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.tabBar}>
        <button
          className={activeTab === 0 ? pageStyles.tabActive : pageStyles.tab}
          onClick={() => setActiveTab(0)}
        >
          Task List
        </button>
        <button
          className={activeTab === 1 ? pageStyles.tabActive : pageStyles.tab}
          onClick={() => setActiveTab(1)}
        >
          Gantt Chart
        </button>
      </div>

      <div className={pageStyles.tabContent}>
        {activeTab === 0 && <TaskTable tasks={tasks} onTasksUpdate={manageTasks} />}
        {activeTab === 1 && <GanttChart tasks={tasks} onTasksUpdate={manageTasks} />}
      </div>
    </div>
  );
}
